export const KB_URL_IMPORT_MAX_PAGES = 300
export const KB_URL_IMPORT_DEFAULT_MAX_PAGES = 50

export function resolveKbUrlImportDefaultMaxPages(maxPagesLimit: number): number {
  return Math.max(1, Math.min(KB_URL_IMPORT_DEFAULT_MAX_PAGES, maxPagesLimit))
}

/** Plan's remaining document slots, clamped to the per-import page cap. */
export function resolveKbUrlImportMaxPages(
  planLimit: number | null | undefined,
  currentDocumentCount: number | null | undefined,
): number {
  if (typeof planLimit !== "number") return KB_URL_IMPORT_MAX_PAGES
  const remaining = planLimit - Math.max(0, currentDocumentCount ?? 0)
  return Math.max(0, Math.min(remaining, KB_URL_IMPORT_MAX_PAGES))
}
